import type { WShopNewProductsTranslations } from "./pl";

export const de: WShopNewProductsTranslations = {
  title: "Neuheiten",
  showAll: "Alle anzeigen",
  noProducts: "Keine Neuheiten.",
};
